  <script>
    import { onDestroy } from 'svelte'

    import { Route, Router, navigate } from 'svelte-routing'
    import { Spinner, Table, Container, Row, Col, Card, Button, CardHeader, CardTitle } from 'sveltestrap'
    import date from 'date-and-time'
    import mapper from '../../middleware/database/mapper'
    import { Projects } from '../../middleware/database/projects'
    import { currentUser } from '../../stores/current_user'

    let projects = []
    let filteredProjects = []
    let unsubscribeQuery = null
    let loading = false
    let showPage = false

    $: if (!$currentUser) {
        loading = false
        showPage = false
    } else {
        loading = true
        showPage = true
    }

    $: if (loading) {
      //fetchAgents(add filters)
      fetchProjects()
    }

    const fetchProjects = () => {
        unsubscribeQuery = Projects.findAll().onSnapshot(docs => {
          projects = mapper.toList(docs)
          filteredProjects = [...projects]
          loading = false
        }, err => {
          console.log(`Encountered error: ${err}`)
        })
    }

    onDestroy(() => {
        if (unsubscribeQuery)
          unsubscribeQuery()
    })
</script>

<style>
  .cardHeader :global(.card-header) {
    background-color: #fff;
  }
</style>

{#if showPage}
<Container class="mt-5">
  <Row>
    <Col>
      <div class="cardHeader">

        <Card>
          <CardHeader>
            <h4 class="float-left">Projects</h4>
            <Button class="float-right" color="primary" onclick={() => navigate("/projects/create")} disabled={!$currentUser.isAdmin}>Create new project</Button>
          </CardHeader>
          {#if loading}
          <Table hover>
            <tbody>
              <tr><td style="text-align: center"><Spinner size="lg" color="dark" type="grow" /></td></tr>
            </tbody>
          </Table>
        {:else}
          <Table hover>
            <thead>
              <tr>
                  <th>Id</th>
                  <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {#each filteredProjects as project (project.id)}
              <tr on:click={() => navigate(`/projects/edit/${project.id}`)} style="cursor: pointer">
                  <td>{project.id}</td>
                  <td>{project.name}</td>
              </tr>
              {/each}
            </tbody>
          </Table>
        {/if}

        </Card>
      </div>
    </Col>
  </Row>
</Container>
{/if}